module.exports = __webpack_public_path__ + "images/habr-colored-04d955.svg";